import { render, staticRenderFns } from "./Standards.vue?vue&type=template&id=c60f0142&"
import script from "./Standards.vue?vue&type=script&lang=js&"
export * from "./Standards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports